export default "__VITE_ASSET__BMZ556X5__"